import { render, staticRenderFns } from "./dimension-edit.vue?vue&type=template&id=59234c35&scoped=true"
import script from "./dimension-edit.vue?vue&type=script&lang=ts"
export * from "./dimension-edit.vue?vue&type=script&lang=ts"
import style0 from "./dimension-edit.vue?vue&type=style&index=0&id=59234c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59234c35",
  null
  
)

export default component.exports